import React from "react";
import { useLocation } from "react-router-dom";
import { Trans } from "@lingui/macro";
import { NavLink } from "react-router-dom";
import {
  RiLineChartLine,
  RiDashboardLine,
  RiPlantLine,
  RiUserFollowLine,
  RiTrophyLine,
  RiGamepadLine,
} from "react-icons/ri";

import "./MobileBottomNav.css";

export function MobileBottomNav() {
  const location = useLocation();

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <nav className="MobileBottomNav">
      <NavLink
        className={`MobileBottomNav-item${isActive("/v1") || location.pathname === "/trade" ? " active" : ""}`}
        to="/v1/long"
      >
        <RiLineChartLine className="MobileBottomNav-icon" />
        <span className="MobileBottomNav-label">
          <Trans>Trade</Trans>
        </span>
      </NavLink>

      <NavLink
        className={`MobileBottomNav-item${isActive("/dashboard") ? " active" : ""}`}
        to="/dashboard"
      >
        <RiDashboardLine className="MobileBottomNav-icon" />
        <span className="MobileBottomNav-label">
          <Trans>Dashboard</Trans>
        </span>
      </NavLink>

      <NavLink
        className={`MobileBottomNav-item${isActive("/earn") ? " active" : ""}`}
        to="/earn"
      >
        <RiPlantLine className="MobileBottomNav-icon" />
        <span className="MobileBottomNav-label">
          <Trans>Earn</Trans>
        </span>
      </NavLink>

      <NavLink
        className={`MobileBottomNav-item${isActive("/copytrading") ? " active" : ""}`}
        to="/copytrading"
      >
        <RiUserFollowLine className="MobileBottomNav-icon" />
        <span className="MobileBottomNav-label">
          <Trans>Copy</Trans>
        </span>
      </NavLink>

      <NavLink
        className={`MobileBottomNav-item${isActive("/card-packs") ? " active" : ""}`}
        to="/card-packs"
      >
        <RiGamepadLine className="MobileBottomNav-icon" />
        <span className="MobileBottomNav-label">
          <Trans>BESC Draw</Trans>
        </span>
      </NavLink>

      <NavLink
        className={`MobileBottomNav-item${
          isActive("/leaderboard") || isActive("/referrals") || isActive("/buy") ? " active" : ""
        }`}
        to="/leaderboard"
      >
        <RiTrophyLine className="MobileBottomNav-icon" />
        <span className="MobileBottomNav-label">
          <Trans>More</Trans>
        </span>
      </NavLink>
    </nav>
  );
}
